import React, { useState } from "react";
import { Table, Form, Row, Col, Button, Dropdown } from "react-bootstrap";
import AuthorizedPage from "../../component/AuthorizedPage";
import { Role } from "../../domain/Role";
import BuyerApi from "../../api/BuyerApi";
import ProductApi from "../../api/ProductApi";
import ProductPricesForBuyersApi from "../../api/BuyerPricesApi";

// --- TİP TANIMLARI ---
interface ProductPrice {
  id: number;
  productId: number;
  price: number;
  accounterId: number | null; // Backend gönderdiği için tipte kalsın ama kullanmayacağız
  customerId: number;
  buyerProductId: number | null;
}

// --- ÖZEL BİLEŞEN: ARAMALI DROPDOWN ---
const CustomSearchableDropdown = ({
    items,
    selectedValue,
    onSelect,
    placeholder,
    labelKey = "title"
}: any) => {
    const [searchTerm, setSearchTerm] = useState("");

    // Seçili öğeyi bul
    const selectedItem = items.find((i: any) => i.id == selectedValue);

    // Listeyi filtrele
    const filteredItems = items.filter((item: any) =>
        item[labelKey].toString().toLocaleLowerCase('tr-TR').includes(searchTerm.toLocaleLowerCase('tr-TR'))
    );

    return (
        <Dropdown>
            <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start d-flex justify-content-between align-items-center bg-white">
                <span className="text-truncate">{selectedItem ? selectedItem[labelKey] : "Tümü"}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="w-100 p-2 shadow" style={{ maxHeight: "300px", overflowY: "auto" }}>
                <Form.Control
                    autoFocus
                    placeholder={`${placeholder} Ara...`}
                    className="mb-2 sticky-top"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    value={searchTerm}
                />

                <Dropdown.Item onClick={() => onSelect("Tümü")} active={selectedValue === "Tümü"}>
                    Tümü
                </Dropdown.Item>

                <Dropdown.Divider />

                {filteredItems.length > 0 ? (
                    filteredItems.map((item: any) => (
                        <Dropdown.Item
                            key={item.id}
                            onClick={() => onSelect(item.id)}
                            active={selectedValue === item.id}
                        >
                            {item[labelKey]}
                        </Dropdown.Item>
                    ))
                ) : (
                    <div className="text-muted text-center small p-2">Sonuç bulunamadı</div>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

class BuyerProductPricesManagement extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      buyers: [],
      products: [],

      // Filtreler
      selectedBuyer: "Tümü",
      selectedProduct: "Tümü",

      filteredPrices: [] as ProductPrice[],
      loading: false,

      // Düzenleme
      editingPriceId: null,
      editedPriceValue: 0,
      editedBuyerProductId: null as number | null,
      saving: false,
    };
  }

  componentDidMount() {
    this.loadFilters();
    this.loadFilteredPrices();
  }

  async loadFilters() {
    this.setState({ loading: true });
    try {
      const buyerResp = await BuyerApi.listAllCards();
      const productResp = await ProductApi.listAllProductCards();
      // UserAccessApi (Sorumlu) çağrısı kaldırıldı.

      this.setState({
        buyers: buyerResp.success ? buyerResp.data : [],
        products: productResp.success ? productResp.data : [],
      });
    } catch (error) {
      console.error("Filtreler yüklenirken hata oluştu", error);
    }
    this.setState({ loading: false });
  }

  async loadFilteredPrices() {
    this.setState({ loading: true });
    try {
      const params: any = {};
      if (this.state.selectedBuyer !== "Tümü") params.customerId = this.state.selectedBuyer;
      if (this.state.selectedProduct !== "Tümü") params.productId = this.state.selectedProduct;
      // Sorumlu filtresi kaldırıldı.

      const resp = await ProductPricesForBuyersApi.filterPrices(params);
      this.setState({ filteredPrices: resp.success ? resp.data : [] });

    } catch (error) {
      console.error("Fiyatlar yüklenirken hata oluştu", error);
    }
    this.setState({ loading: false });
  }

  handleFilterClick = () => {
    this.loadFilteredPrices();
  };

  // --- İSİM GETİRME YARDIMCILARI ---

  getBuyerName(customerId: number) {
    const buyer = this.state.buyers.find((b: any) => b.id === customerId);
    return buyer ? buyer.title : "";
  }

  getProductName(productId: number) {
    const product = this.state.products.find((p: any) => p.id === productId);
    return product ? product.description : "";
  }

  // --- DÜZENLEME İŞLEMLERİ ---

  startEditing = (id: number, currentPrice: number, currentBuyerProductId: number | null) => {
    this.setState({
      editingPriceId: id,
      editedPriceValue: currentPrice,
      editedBuyerProductId: currentBuyerProductId
    });
  };

  cancelEditing = () => {
    this.setState({
      editingPriceId: null,
      editedPriceValue: 0,
      editedBuyerProductId: null
    });
  };

  handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedPriceValue: e.target.value });
  };

  handleBuyerProductChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    this.setState({ editedBuyerProductId: value ? parseInt(value) : null });
  };

  savePrice = async (id: number) => {
    this.setState({ saving: true });
    try {
      const data = {
        id,
        price: parseFloat(this.state.editedPriceValue),
        buyerProductId: this.state.editedBuyerProductId
      };
      const resp = await ProductPricesForBuyersApi.update(data);

      if (resp.success) {
        await this.loadFilteredPrices();
        this.setState({ editingPriceId: null });
      } else {
        alert("Güncelleme başarısız!");
      }
    } catch (error) {
      console.error("Fiyat güncelleme hatası", error);
      alert("Bir hata oluştu.");
    }
    this.setState({ saving: false });
  };

  render() {
    const {
      buyers,
      products,
      filteredPrices,
      loading,
      editingPriceId,
      editedPriceValue,
      editedBuyerProductId,
      saving,
      selectedBuyer,
      selectedProduct
    } = this.state;

    return (
      <AuthorizedPage role={Role.ACCOUNTING_MANAGER}>
        <div className="container mt-4">
          <h3>Müşteri Ürün Fiyatları</h3>

          {/* FİLTRE ALANI */}
          <div className="p-3 mb-3 bg-light border rounded">
            <Row>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="fw-bold text-muted small">Müşteri</Form.Label>
                        <CustomSearchableDropdown
                            items={buyers}
                            selectedValue={selectedBuyer}
                            onSelect={(val: any) => this.setState({ selectedBuyer: val })}
                            placeholder="Müşteri"
                            labelKey="title"
                        />
                    </Form.Group>
                </Col>

                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="fw-bold text-muted small">Ürün</Form.Label>
                        <CustomSearchableDropdown
                            items={products}
                            selectedValue={selectedProduct}
                            onSelect={(val: any) => this.setState({ selectedProduct: val })}
                            placeholder="Ürün"
                            labelKey="description"
                        />
                    </Form.Group>
                </Col>

                <Col md={4} className="d-flex align-items-end">
                    <Button
                        onClick={this.handleFilterClick}
                        disabled={loading}
                        className="w-100"
                        variant="primary"
                    >
                        {loading ? "Yükleniyor..." : "🔍 Verileri Getir"}
                    </Button>
                </Col>
            </Row>
          </div>

          <Table striped bordered hover responsive className="bg-white shadow-sm">
            <thead className="bg-light">
              <tr>
                <th>Müşteri</th>
                <th>Ürün</th>
                {/* Sorumlu kolonu kaldırıldı */}
                <th style={{width: "150px"}}>Fiyat(₺)</th>
                <th style={{width: "150px"}}>Müşteri Ürün Kodu</th>
                <th style={{width: "180px"}}>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {filteredPrices.length === 0 ? (
                  <tr><td colSpan={5} className="text-center p-4 text-muted">Kayıt bulunamadı. Lütfen filtreleme yapınız.</td></tr>
              ) : (
                filteredPrices.map((item: ProductPrice) => (
                    <tr key={item.id}>
                    <td className="align-middle">{this.getBuyerName(item.customerId)}</td>
                    <td className="align-middle">{this.getProductName(item.productId)}</td>
                    {/* Sorumlu hücresi kaldırıldı */}
                    <td className="align-middle">
                        {editingPriceId === item.id ? (
                        <Form.Control
                            type="number"
                            value={editedPriceValue}
                            onChange={this.handlePriceChange}
                            size="sm"
                        />
                        ) : (
                        <span className="fw-bold">{item.price} ₺</span>
                        )}
                    </td>
                    <td className="align-middle">
                        {editingPriceId === item.id ? (
                        <Form.Control
                            type="number"
                            value={editedBuyerProductId ?? ""}
                            onChange={this.handleBuyerProductChange}
                            size="sm"
                            placeholder="Kod Yok"
                        />
                        ) : (
                        item.buyerProductId ?? <span className="text-muted small">-</span>
                        )}
                    </td>
                    <td className="align-middle">
                        {editingPriceId === item.id ? (
                        <>
                            <Button
                            variant="success"
                            size="sm"
                            className="me-2"
                            onClick={() => this.savePrice(item.id)}
                            disabled={saving}
                            >
                            {saving ? "..." : "Kaydet"}
                            </Button>
                            <Button variant="outline-secondary" size="sm" onClick={this.cancelEditing}>
                            İptal
                            </Button>
                        </>
                        ) : (
                        <Button
                            variant="warning"
                            size="sm"
                            onClick={() => this.startEditing(item.id, item.price, item.buyerProductId)}
                        >
                            Düzenle
                        </Button>
                        )}
                    </td>
                    </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </AuthorizedPage>
    );
  }
}

export default BuyerProductPricesManagement;